import { useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useEffect, useMemo, useState } from 'react';
import { WidgetLoader } from 'datastake-daf/dist/components';
import { defaultFilters } from "datastake-daf/src/helpers/Table";
import DTable from './dTable';
import getColumns from './columns';
import AdminService from '../../../services/AdminService';
import { filterParams } from '../../../helpers/SubjectSearch';
import { getFilters } from '../../../components/Forms/projects/table/config';

export default function DeletionsTable({
  tabKey = '',
  currentKey = '',
  changeFilters = () => { },
}) {
  const { t } = useTranslation();
  const [data, setData] = useState({ data: [], options: {}, totalItems: 0 });
  const [loading, setLoading] = useState(true);
  const [loaded, setLoaded] = useState(false);
  const location = useLocation();
  const params = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const [activeFilters, setActiveFilters] = useState(
    params.has('deleteFilters')
      ? getFilters(params, 'deleteFilters', 'deleted')
      : defaultFilters
  );

  const columns = useMemo(() => getColumns({ t, activeFilters }), [t, activeFilters]);

  const getDeletions = async () => {
    try {
      setLoading(true);

      const params = filterParams({ activeFilters });

      const key = tabKey === 'events' ? 'event' : tabKey;
      const { data } = await AdminService.getDeletions(key, params);
      setData(data);

      if (!loaded) {
        setLoaded(true);
      }

      setLoading(false);
    } catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    setLoading(true);
    getDeletions(currentKey, () => {
      setLoading(false);
    });
  }, [activeFilters]);

  useEffect(() => {
    changeFilters(activeFilters);
  }, [activeFilters]);

  return (
    <div style={{ minHeight: 200 }}>
      {loading && <WidgetLoader />}
      {loaded && (
        <DTable
          data={data}
          style={{ marginTop: '12px' }}
          bordered={true}
          columns={columns}
          state={tabKey}
          defaultActiveFilters={activeFilters}
          setActiveFilters={setActiveFilters}
        />
      )}
    </div>
  );
}
